import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Moon } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Sel } from "@/components/radar/Bits";
import { ago, browserTz, hourLabel, rErr, rPut, useQ } from "@/lib/radar";

// §50 nightly auto-add of workflow signal companies + radar run + morning email.
export const AutoAdd = () => {
  const q = useQ("/admin/rcc/radar/auto-add");
  const [s, setS] = useState(null);
  useEffect(() => { if (q.data) setS(q.data); }, [q.data]);
  if (q.missing) return <p className="text-[11px] text-zinc-500" data-testid="radar-autoadd-missing"><Moon className="mr-1 inline h-3 w-3" />Nightly auto-add turns on once the backend adds it (backend-spec §50).</p>;
  if (!s) return null;
  const save = async (patch) => {
    const next = { ...s, ...patch };
    setS(next);
    try { const r = await rPut("/auto-add", { enabled: !!next.enabled, hour: Number(next.hour ?? 2), timezone: next.timezone || browserTz(), run_radar: true, email_summary: true }); setS(r || next); if ("enabled" in patch) toast.success(next.enabled ? "Nightly auto-add is on" : "Nightly auto-add is off"); }
    catch (e) { setS(s); toast.error(rErr(e)); }
  };
  const lr = s.last_result;
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl border border-[#27272A] bg-[#0f0f12] px-3 py-2" data-testid="radar-autoadd">
      <Moon className="h-4 w-4 text-[#c79bff]" />
      <label className="flex items-center gap-2 text-xs text-zinc-200"><Switch checked={!!s.enabled} onCheckedChange={(v) => save({ enabled: v })} data-testid="radar-autoadd-toggle" />Every night, add new signal companies and run the radar on them</label>
      <Sel value={String(s.hour ?? 2)} onChange={(v) => save({ hour: v || 2 })} label="Hour" options={Array.from({ length: 24 }, (_, h) => [String(h), hourLabel(h)])} testid="radar-autoadd-hour" />
      <span className="text-[11px] text-zinc-500">{String(s.timezone || browserTz()).split("/").pop().replace(/_/g, " ")}{s.timezone !== browserTz() && <button onClick={() => save({ timezone: browserTz() })} className="ml-1 text-[#D4AF37] hover:underline" data-testid="radar-autoadd-tz">use mine</button>}</span>
      <span className="w-full text-[11px] text-zinc-500 md:ml-auto md:w-auto" data-testid="radar-autoadd-last">Summary email to {s.to || "hello@rpopro.co"} in the morning{s.last_run_at ? ` · last night ${ago(s.last_run_at)}: ${lr?.added ?? 0} added, ${lr?.ran ?? 0} researched${lr?.emailed ? ", emailed" : ""}` : ""}</span>
    </div>
  );
};
